import { numberComparatorMax2, numberFilterParams, createNumberFormatter } from "@icarius-table/number";
import { getLocalizedString } from "@icarius-localization/strings";

export default () => [
    {
        pages: ['typesOfSkillsIndicators'],
        config: {
            headerName: getLocalizedString("skillsCode"),
            field: "code",
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: ['typesOfSkillsIndicators'],
        config: {
            headerName: getLocalizedString("indicatorNumber"),
            field: "indicatorNumber",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            cellClass: "currencyValueNoDecimal",
            valueFormatter: createNumberFormatter(0, 0),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: ['typesOfSkillsIndicators'],
        config: {
            headerName: getLocalizedString("indicatorName"),
            field: "indicatorName",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['typesOfSkillsIndicators'],
        config: {
            headerName: getLocalizedString("behaviorDescription"),
            field: "behaviorDescription",
            filter: "agTextColumnFilter",
        }
    },
]